var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnSubmittedPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 13,
    viewBox: "0 0 12 13",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.787 5.571c1.538 0 2.785-1.247 2.785-2.785s-1.247-2.786-2.785-2.786-2.787 1.248-2.787 2.786 1.249 2.784 2.787 2.784zm0-4.526c.96 0 1.74.78 1.74 1.74 0 .961-.78 1.742-1.74 1.742s-1.741-.78-1.741-1.741c0-.96.78-1.741 1.74-1.741zm5.571 6.384c-1.538 0-2.786 1.247-2.786 2.785s1.248 2.786 2.786 2.786 2.786-1.248 2.786-2.786-1.248-2.784-2.786-2.784zm0 4.526c-.96 0-1.74-.78-1.74-1.74 0-.961.78-1.742 1.74-1.742s1.741.78 1.741 1.741c0 .96-.78 1.741-1.74 1.741zm1.735-11.955h.877c.145 0 .226.165.14.279l-9.92 12.651c-.031.044-.083.07-.139.07h-.876c-.145 0-.226-.165-.14-.279l9.921-12.651c.031-.044.083-.07.138-.07z",
    fill: "#11a56a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSubmittedPercent);
export default __webpack_public_path__ + "static/media/icn_submitted_percent.103f7c188302b04d656fbbdabcaed0b6.svg";
export { ForwardRef as ReactComponent };